import { RouterModule, Routes } from '@angular/router';

import {
    AnschriftComponent,
    BankdatenComponent,
    BeitragWithRateComponent,
    CanDeactivateGuardService,
    DownloadComponent,
    GuardService,
    StandardAntragComponent,
    StandardBeitragComponent,
} from '@vhv/tarifrechner-common';

import { CyberZusammenfassungComponent } from '../views/antrag/cyber-zusammenfassung.component';
import { CyberBetriebsartComponent } from '../views/betriebsart/cyber-betriebsart.component';
import { CyberBausteineComponent } from '../views/cyber-bausteine/cyber-bausteine.component';
import { CyberSicherheitsvorkehrungenComponent } from '../views/sicherheitsvorkehrungen/cyber-sicherheitsvorkehrungen.component';
import { CyberBeitragComponent } from '../views/beitrag/cyber-beitrag.component';
import { CyberAnfrageDankeComponent } from '../views/antrag/cyber-anfrage-danke.component';
import { CyberErrorComponent } from '../views/error/cyber-error.component';
import { CyberDankeComponent } from '../views/antrag/cyber-danke.component';


const routes: Routes = [
    {
        path: "intro",
        pathMatch: "full",
        component: CyberBetriebsartComponent,
    },
    {
        path: "beitrag/:seitenName",
        component: StandardBeitragComponent,
        canActivate: [GuardService]
    },
    {
        path: "bausteine/:seitenName",
        component: CyberBausteineComponent,
        canActivate: [GuardService]
    },
    {
        path: "beitragRate/:seitenName",
        component: BeitragWithRateComponent,
        canActivate: [GuardService]
    },
    {
        path: "beitragErgebnis/:seitenName",
        component: CyberBeitragComponent,
        canActivate: [GuardService]
    },
    {
        path: "antrag/:seitenName",
        component: StandardAntragComponent,
        canActivate: [GuardService]
    },
    {
        path: "bankdaten/:seitenName",
        component: BankdatenComponent,
        canActivate: [GuardService]
    },
    {
        path: "sicherheitsvorkehrungen/:seitenName",
        component: CyberSicherheitsvorkehrungenComponent,
        canActivate: [GuardService]
    },
    {
        path: "anschrift/:seitenName",
        component: AnschriftComponent,
        canActivate: [GuardService]
    },
    {
        path: "download/:seitenName",
        component: DownloadComponent,
        canActivate: [GuardService]
    },
    {
        path: "zusammenfassung/:seitenName",
        component: CyberZusammenfassungComponent,
        canActivate: [GuardService]
    },
    {
        path: "danke/:seitenName",
        component: CyberDankeComponent,
        canActivate: [GuardService],
        canDeactivate: [CanDeactivateGuardService]
    },
    {
        path: "dankeAnfrage/:seitenName",
        component: CyberAnfrageDankeComponent,
        canActivate: [GuardService],
        canDeactivate: [CanDeactivateGuardService]
    },
    {
        path: "error",
        component: CyberErrorComponent
    },
    {
        path: "**",
        redirectTo: "/",
        pathMatch: "full"
    }
];

export const AppRouting = RouterModule.forRoot(routes, { enableTracing: false });
